import { render, staticRenderFns } from "./ChevronUpIcon.vue?vue&type=template&id=a8e5b0d6&scoped=true&"
import script from "./ChevronUpIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ChevronUpIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e5b0d6",
  null
  
)

export default component.exports